<template>
  <div id="deliverySite">
    <!-- 订单默认模式 -->
    <div class="orderDefaultModeBar">
      <div class="orderDefaultModeHeader">
        <div class="orderModeIconBox">
          <img :src="require('@/assets/icon/CheckTwin.svg')" alt="" />
        </div>
        <!-- 订单默认模式 -->
        <span>{{ $fanyi("订单默认模式") }}</span>
      </div>
      <div class="orderDefaultModeOptions">
        <div
          class="orderDefaultModeOpt"
          v-for="item in orderModeList"
          :key="item.value"
          @click="chioseOrderDefaultMode(item.value)"
        >
          <div
            class="modeCheckbox"
            :class="{ checked: order_default_mode === item.value }"
          ></div>
          <div class="modeLabelRow">
            <!-- DAP模式自税 / 普通订单 -->
            <span class="modeLabel">{{ $fanyi(item.label) }}</span>
            <el-popover
              placement="top-start"
              width="320"
              trigger="click"
              popper-class="order-mode-tip-popover"
            >
              <div class="orderModeTipContent">
                {{ $fanyi(item.tipKey) }}
              </div>
              <div slot="reference" class="orderModeTip" @click.stop>
                <img :src="require('@/assets/icon/QuestMark.svg')" alt="" />
              </div>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
    <!-- 进口商 -->
    <div class="con">
      <div
        class="opt"
        v-for="(item, index) in importer"
        :key="index"
        :class="{ acquiescent: item.acquiescent }"
      >
        <div class="h1Title">
          <!-- 购买方 -->
          <span> {{ $fanyi("购买方") }}{{ index + 1 }}</span>
          <span class="defaultAddress" v-if="item.acquiescent">
            <!-- 默认 -->
            {{ $fanyi("默认") }}
          </span>
        </div>
        <p>
          <!-- 购买人身份 -->
          <label for="">{{ $fanyi("购买人身份") }}：</label>
          <span :title="getEntityTypeLabel(item)">{{
            getEntityTypeLabel(item)
          }}</span>
        </p>
        <p>
          <label for="">{{ $fanyi("全名") }}：</label>
          <span :title="item.contacts">{{ item.contacts }}</span>
        </p>
        <p>
          <label for="">{{ $fanyi("邮编") }}：</label>
          <span :title="item.zip_code">{{ item.zip_code }}</span>
        </p>
        <p>
          <!-- 城市 -->
          <label for="">{{ $fanyi("城市") }}：</label>
          <span :title="item.city">{{ item.city }}</span>
        </p>
        <p>
          <label for="">{{ $fanyi("省份") }}：</label>
          <span :title="item.province">{{ item.province }}</span>
        </p>
        <p>
          <label for="">{{ $fanyi("国家") }}：</label>
          <span :title="item.country">{{ item.country }}</span>
        </p>
        <p class="address">
          <label for="">{{ $fanyi("地址") }}：</label>
          <span :title="item.address">{{ item.address }}</span>
        </p>
        <p>
          <label for="">{{ $fanyi("电话") }}：</label>
          <span :title="item.mobile">{{ item.mobile }}</span>
        </p>
        <p class="address">
          <!-- 电子邮件 -->
          <label for="">{{ $fanyi("电子邮件") }}：</label>
          <span :title="item.email">{{ item.email }}</span>
        </p>

        <template v-if="isCompanyItem(item)">
          <p>
            <!-- C.F. / Fiscal Code -->
            <label for="">{{ $fanyi("C.F. / Fiscal Code") }}：</label>
            <span :title="item.cnpj">{{ item.cnpj }}</span>
          </p>
          <p>
            <!-- P.IVA/VAT NO -->
            <label for="">{{ $fanyi("P.IVA/VAT NO") }}：</label>
            <span :title="item.vat_number">{{ item.vat_number }}</span>
          </p>
          <p>
            <!-- Codice Destinatario SDI -->
            <label for="">{{ $fanyi("Codice Destinatario SDI") }}：</label>
            <span :title="item.sdi">{{ item.sdi }}</span>
          </p>
        </template>
        <!-- 操作 -->
        <div class="btn">
          <el-button class=" uiBtn uiGreen2" @click="edit(item)">{{
            $fanyi("编辑")
          }}</el-button>
        </div>
      </div>
      <div class="add opt " @click="openAddAddressWin">
        <div>
          <img src="../../../../assets/user-img/tianJia.svg" alt="" />
          <span>{{ $fanyi("新增地址") }}</span>
        </div>
      </div>
    </div>
    <InvoiceBillingAddressDialog
      ref="addressDialog"
      :address-type="type"
      @success="useraddressList"
    />
  </div>
</template>

<script>
import InvoiceBillingAddressDialog from "./components/InvoiceBillingAddressDialog.vue";

export default {
  components: {
    InvoiceBillingAddressDialog,
  },
  data() {
    return {
      type: 2,
      consignee: [],
      importer: [],
      // 0 未设置 1-DAP 2-普通订单
      order_default_mode: 0,
      orderModeSaving: false,
      orderModeList: [
        {
          value: 1,
          label: "DAP模式自税",
          tipKey:
            "DAP（客户EORI清关模式）：RAKUMART全程负责运输至指定目的地。清关阶段将调用您的EORI号，并同步提供欧盟标准SAD/DUA清关凭证。清关产生的关税、VAT等相关税费需由客户自行依法缴纳。",
        },
        {
          value: 2,
          label: "普通订单",
          tipKey:
            "标准订单模式（RAKUMART代清关）：采用RAKUMART税号进行清关，实现“中国仓到最终目的地”的一站式闭环服务。我们将为您提供包含RAKUMART税号的合规商业发票，确保货物清关及后续税务合规。",
        },
      ],
      // 购买人身份映射：findName 按 value 匹配存储值，返回 key 展示文案
      entityTypeList: [
        { key: "公司进口商", value: 1 },
        { key: "个人", value: 2 },
      ],
    };
  },

  created() {
    this.initOrderDefaultModeFromStore();
    this.useraddressList();
  },
  methods: {
    // 从 store.userInfo 初始化订单默认模式
    initOrderDefaultModeFromStore() {
      const userMode = Number(
        (this.$store.state.userInfo || {}).order_default_mode
      );
      this.order_default_mode = userMode === 1 || userMode === 2 ? userMode : 0;
    },
    // 选择并保存订单默认模式
    chioseOrderDefaultMode(value) {
      if (this.orderModeSaving || this.order_default_mode === value) return;
      this.orderModeSaving = true;
      this.$api
        .orderDefaultModeSave({ order_default_mode: value })
        .then((res) => {
          this.orderModeSaving = false;
          if (res.code != 0) return this.$message.error(this.$fanyi(res.msg));
          this.order_default_mode = value;
          if (this.$store.state.userInfo) {
            this.$store.commit("userData", {
              ...this.$store.state.userInfo,
              order_default_mode: value,
            });
          }
          this.$message.success(this.$fanyi("保存成功"));
        })
        .catch(() => {
          this.orderModeSaving = false;
        });
    },
    // 是否为公司进口商，控制税号类字段在卡片中是否展示
    isCompanyItem(item) {
      return Number(item.entity_type) !== 2;
    },
    // 购买人身份展示文案：entity_type 数值映射为可读名称
    getEntityTypeLabel(item) {
      const typeKey = item.entity_type ? Number(item.entity_type) : 1;
      const label = this.$fun.findName(this.entityTypeList, typeKey);
      return this.$fanyi(typeof label === "string" ? label : "公司进口商");
    },
    openAddAddressWin() {
      this.$refs.addressDialog.openAdd();
    },
    edit(item) {
      this.$refs.addressDialog.openEdit(item);
    },
    // // 同步
    // synchronization(item) {
    //   let msg = this.type == 2 ? "收件人" : "进口商";
    //   item.type = this.type == 2 ? 1 : 2;
    //   item.acquiescent = 0;
    //   this.$confirm(this.$fanyi("是否同步到" + msg), this.$fanyi("提示"), {
    //     confirmButtonText: this.$fanyi("确定"),
    //     cancelButtonText: this.$fanyi("取消"),
    //     type: "warning",
    //     center: true,
    //   }).then(() => {
    //     this.$api.useraddressAdd(item).then((res) => {
    //       if (res.code != 0) return this.$message.error(this.$fanyi(res.msg));
    //
    //       this.useraddressList();
    //       this.dialogVisible = false;
    //       this.$message.success(this.$fanyi("保存成功"));
    //     });
    //   });
    // },
    // 获取数据
    useraddressList() {
      this.consignee = [];
      this.importer = [];
      this.$api.useraddressList().then((res) => {
        // //console.log("useraddressList", res);

        if (res.data.consignee) {
          this.consignee = res.data.consignee;
        }
        if (res.data.importer) {
          this.importer = res.data.importer;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../css/mixin";
#deliverySite {
  background-color: #f8f7f7;
  .orderDefaultModeBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
    min-height: 74px;
    padding: 20px 40px 20px 20px;
    margin-bottom: 20px;
    background: #ffffff;
    border: 1px solid #eaecf0;
    border-radius: 12px;
    .orderDefaultModeHeader {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      height: 34px;
      span {
        display: inline-flex;
        align-items: center;
        height: 34px;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        color: #344554;
      }
    }
    .orderModeIconBox {
      width: 34px;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      line-height: 0;
      img {
        width: 34px;
        height: 34px;
        display: block;
        object-fit: contain;
        object-position: center;
        transform: translateY(2px);
      }
    }
    .orderDefaultModeOptions {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 40px;
      flex-shrink: 0;
      height: 34px;
    }
    .orderDefaultModeOpt {
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
      flex-shrink: 0;
      height: 34px;
      .modeCheckbox {
        width: 22px;
        height: 22px;
        border-radius: 4px;
        border: 1px solid #acadaf;
        background: #ffffff;
        flex-shrink: 0;
        position: relative;
        &.checked {
          background: #009246;
          border-color: #009246;
          &::after {
            content: "";
            position: absolute;
            left: 7px;
            top: 4px;
            width: 5px;
            height: 9px;
            border: solid #ffffff;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
          }
        }
      }
      .modeLabelRow {
        display: flex;
        align-items: center;
        gap: 4px;
        min-width: 0;
        min-height: 22px;
        /deep/ .el-popover__reference-wrapper {
          display: inline-flex;
          align-items: center;
          align-self: center;
          line-height: 0;
        }
      }
      .modeLabel {
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        color: #000000;
        word-break: break-word;
      }
      .orderModeTip {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        cursor: pointer;

        img {
          width: 16px;
          height: 16px;
          transform: translateY(3px);
        }
      }
    }
  }
  nav {
    display: flex;
    span {
      display: block;
      width: 130px;
      height: 50px;
      background: #e8e8e8;
      border: 1px solid #e1e1e1;
      border-bottom: none;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      &.active {
        background: #ffffff;
      }
    }
  }
  .con {
    background-color: white;
    display: flex;
    flex-wrap: wrap;
    background-color: white;
    padding: 20px;
    border: 1px solid #eaecf0;
    border-radius: 12px;
    > .opt {
      // 进口商卡片一行展示两个，间距 20px
      width: calc((100% - 20px) / 2);
      min-height: 496px;
      background: #ffffff;
      border: 1px solid $homePageSubjectColor;
      border-radius: 10px;
      padding: 24px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-right: 20px;
      margin-bottom: 20px;
      &:nth-child(2n) {
        margin-right: 0;
      }
      .h1Title {
        height: unset;
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
          width: max-content;
          font-size: 18px;
          font-weight: bold;
          color: #000000;
        }
        span.defaultAddress {
          @extend .dip;
          width: max-content;
          padding: 0 8px;
          height: 24px;
          border: 1px solid #ffa018;
          border-radius: 6px;
          font-size: 12px;
          text-align: center;
          color: #ffa018;
        }
      }
      p {
        display: flex;
        margin-bottom: 12px;
        label {
          display: inline-block;
          flex: 0 0 132px;
          font-size: 14px;
          line-height: 16px;
          font-weight: 400;
          margin-right: 10px;
        }
        span {
          display: inline-block;
          font-size: 14px;
          line-height: 16px;
          display: block;
          font-weight: 400;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &.address {
          max-height: none;
          align-items: flex-start;
          span {
            flex: 1;
            min-width: 0;
            white-space: normal;
            word-break: break-word;
            line-height: 16px;
            max-height: calc(16px * 2);
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
      .btn {
        text-align: center;
        margin-top: 10px;
        display: flex;
        align-items: center;
        button {
          height: 36px;
          border-radius: 8px;
          font-size: 14px;
          padding: 0 16px;
          line-height: 20px;
        }
      }
      &.add {
        cursor: pointer;
        background: #ffffff;
        border: 1px solid #eaecf0 !important;
        border: none;
        text-align: center;
        height: 430px;
        > div {
          cursor: pointer;
        }
        img {
          width: 32px;
          height: 32px;
          display: block;
          margin: 0 auto 16px;
        }
        span {
          font-size: 18px;
          font-weight: 600;
          color: #d0d5dd;
        }
      }
    }
    .acquiescent {
      background-color: #fcfcff;
    }
  }
}
</style>
<style lang="scss">
.orderModeTipContent {
  font-size: 14px;
  line-height: 22px;
  color: #2f2f2f;
  text-align: left;
}
</style>
